<template>

  <div class="hit-container">

    <slot v-if="is_logged_in()"></slot>

    <div v-if="!is_logged_in()">
      <div class="hit-col-md-6 hit-col-md-hit-offset-3">

  			<div class="hit-panel hit-panel-primary hit-html-html">
  				<div class="hit-panel-heading">
  					{{ $t('message.youAreNotLoggedIn') }}
  				</div>
  				<div class="hit-panel-body">
            <router-link class=" hit-btn hit-btn-default hit-btn-block" :to="{ name: 'sign_in', params: {lang: $store.getters.lang} }">{{ $t('message.signIn') }}</router-link>
        </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default{

  data () {
    return {
    // is_logged_in: false
    }
  },

  methods: {

    is_logged_in () {
      if (typeof this.$store === 'object' && typeof this.$store.getters === 'object' && typeof this.$store.getters.user === 'object') {
        return true
      }

      return false
    }

  }

}
</script>
